import React, { createElement, Children, isValidElement, useEffect } from 'react';
import './index.scss';
import { CollapseSelectorItem } from '../collapse-selector-item/index';
const CollapseSelector = (props) => {
    const { children } = props;
    const [activeKey, setActiveKey] = React.useState(null);
    const handleItemClick = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    useEffect(() => {
        if (children) {
            let firstKey = null;
            Children.forEach(children, (child) => {
                if (isValidElement(child) && child.type === CollapseSelectorItem && !firstKey) {
                    firstKey = child.props.key || '';
                }
            });
            if (firstKey) {
                setActiveKey(firstKey);
            }
        }
        else if (props.dataList && props.dataList.length > 0) {
            const firstKey = props.dataList[0].key || '';
            if (firstKey) {
                setActiveKey(firstKey);
            }
        }
    }, [children, props.dataList]);
    if (children) {
        return createElement('div', { className: 'collapse-selector' }, Children.map(children, (child) => {
            if (isValidElement(child) && child.type === CollapseSelectorItem) {
                const childKey = child.props.key || '';
                const isActive = activeKey === childKey;
                return createElement('div', { key: childKey, className: 'collapse-selector-item' }, [
                    createElement('div', {
                        className: 'collapse-selector-header',
                        onClick: () => handleItemClick(childKey),
                    }, [
                        createElement('div', { className: 'collapse-selector-title' }, [
                            child.props.icon &&
                                createElement('i', { className: `collapse-selector-icon ${child.props.icon}` }),
                            createElement('span', null, child.props.title),
                        ]),
                        createElement('div', {
                            className: `collapse-selector-indicator ${isActive ? 'active' : ''}`,
                        }),
                    ]),
                    isActive && createElement('div', { className: 'collapse-selector-content' }, child),
                ]);
            }
            return null;
        }));
    }
    const { dataList = [] } = props;
    return createElement('div', { className: 'collapse-selector' }, dataList.map((item) => createElement('div', { key: item.key, className: 'collapse-selector-item' }, [
        createElement('div', {
            className: 'collapse-selector-header',
            onClick: () => handleItemClick(item.key || ''),
        }, [
            createElement('div', { className: 'collapse-selector-title' }, [
                item.icon && createElement('i', { className: `collapse-selector-icon ${item.icon}` }),
                createElement('span', null, item.title),
            ]),
            createElement('div', {
                className: `collapse-selector-indicator ${activeKey === item.key ? 'active' : ''}`,
            }),
        ]),
        item.isContent &&
            activeKey === item.key &&
            createElement('div', { className: 'collapse-selector-content' }, createElement(CollapseSelectorItem, { title: item.title, key: item.key })),
    ])));
};
CollapseSelector.displayName = 'CollapseSelector';
export default CollapseSelector;
